import React from 'react';
import { DialogProvider } from './src/contexts/DialogContext';

require('prismjs/plugins/command-line/prism-command-line.css');
require('prismjs/plugins/line-numbers/prism-line-numbers.css');

export const wrapRootElement = ({ element }) => (
  <DialogProvider>{element}</DialogProvider>
);

export const onRouteUpdate = ({ location }) => {
  // Dispatch a custom event that your hook can listen to
  window.dispatchEvent(new Event('routeChanged'));

  if (process.env.NODE_ENV !== 'production') return;

  // Page views on client-side navigation, previously sent by
  // gatsby-plugin-posthog and gatsby-plugin-hubspot. The scripts themselves
  // are injected in gatsby-ssr.js.
  if (window.posthog) {
    window.posthog.capture('$pageview');
  }

  if (Array.isArray(window._hsq)) {
    const trackPageView = () => {
      const path = location
        ? `${location.pathname}${location.search}${location.hash}`
        : undefined;
      window._hsq.push(['setPath', path]);
      window._hsq.push(['trackPageView']);
    };
    // Wait two frames so react-helmet has updated the document title.
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(() =>
        window.requestAnimationFrame(trackPageView),
      );
    } else {
      setTimeout(trackPageView, 32);
    }
  }
};
